import React, {
  useEffect,
  createContext,
  useCallback,
  useState,
  useContext,
} from 'react';

import { store } from 'react-notifications-component';
import api from '../services/api';

const SearchContext = createContext({});

export const SearchProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [searches, setSearches] = useState([]);

  async function loadSearches() {
    api.get(`searchareas`).then(({ data }) => {
      setSearches(data);

      api.get(`connections`).then(({ data: connections }) => {
        setSearches([...data, ...connections]);
      });
    });
  }

  useEffect(() => {
    loadSearches();
  }, []);

  const create = useCallback(async (data) => {
    setLoading(true);

    api.post(`searchareas`, data).then(({ data: searcharea }) => {
      setSearches([...searches, searcharea]);

      store.addNotification({
        message: `Área de pesquisa inserida com sucesso!`,
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }).finally(() => {
      setLoading(false);
    });
  }, [searches]);

  const update = useCallback(async (data) => {
    setLoading(true);

    api.put(`searchareas/${data.id}`, data).then(({ data: searcharea }) => {
      setSearches(searches.map((item) => (item.id === data.id ? searcharea : item)));
      loadSearches();

      store.addNotification({
        message: `Área de pesquisa atualizada com sucesso!`,
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }).finally(() => {
      setLoading(false);
    });
  }, [searches]);

  const erase = useCallback(async (data) => {
    setLoading(true);

    api.delete(`searchareas/${data.id}`).then(() => {
      setSearches(searches.filter((item) => (item.id !== data.id)));
      loadSearches();

      store.addNotification({
        message: `Área de pesquisa deletada com sucesso!`,
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    }).finally(() => {
      setLoading(false);
    });
  }, [searches]);

  return (
    <SearchContext.Provider
      value={{
        searches,
        loading,
        create,
        update,
        erase,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export function useSearch() {
  const context = useContext(SearchContext);

  if (!context) {
    throw Error('useSearch must be used within an SearchProvider');
  }

  return context;
}
